export enum MarketplacePaymentsTableColumnId {
  PaymentDate = 'paymentDate',
  PaymentReferenceID = 'paymentReferenceID',
  ExternalPaymentID = 'ExternalPaymentID',
  State = 'state',
  PaymentAmount = 'paymentAmount',
  CreditAmount = 'creditAmount',
  ChargeAmount = 'chargeAmount',
  ProceedsAmount = 'proceedsAmount',
  Marketplace = 'marketplace',
  ConvertedPaymentsAmount = 'convertedPaymentAmount',
  Actions = 'actions',
}
